import gql from 'graphql-tag';

export const GET_PUBLIC_PROFILE = gql`
  query publicProfile (
    $publicProfileId: ID!,
  ) {
    PublicProfile(
      publicProfileId: $publicProfileId,
    ) {
      id,
      title,
      description,
      donateLink,
      public,
      creationDate { formatted },
      lastModifiedDate { formatted },
      owners {
        id,
        accountId,
        fullName,
        alias,
        description,
        imageDepictions {
          id,
          title,
          type,
          file {
            id,
            filename,
            uri,
            size
          }
          thumbnail { 
            id, 
            file { 
              uri 
              } 
          }
        }
      }
      videos {
        id,
        url,
        creationDate {
            formatted
          }
        }
      }
    }
`;

export const CREATE_PUBLIC_PROFILE = gql`
  mutation createPublicProfile (
    $partyId: ID!, 
    $input:PublicProfileInput
  ){
    CreatePublicProfile (
      partyId: $partyId, 
      input: $input
    ) {
      id
  }
}
`;

export const UPDATE_PUBLIC_PROFILE = gql`
  mutation updatePublicProfile (
    $partyId: ID!, 
      $input:PublicProfileInput
      ){
    UpdatePublicProfile (
      partyId: $partyId, 
      input: $input
    ) {
      id,
      title,
      description,
      donateLink,
      owners {
        id,
        fullName,
        description
      }
  }
}
`;
